<!--Vista de sección de ¿Cómo funciona?-->
<template>
  <v-container fluid class="pa-0">
    <v-row justify="space-around" align="center" class="mt-5 pt-5">
      <v-col cols="12">
        <h1 class="display-2 text-center font-weight-bold">¿Cómo funciona?</h1>
      </v-col>
    </v-row>

    <v-row justify="center" align="center" class="pa-5 my-md-5 mt-0 mb-5">
      <v-col cols="12" sm="6" md="5" lg="6" xl="4" class="text-center mx-md-5">
        <h1 class="display-2 font-weight-black">{{ stepsData[0].title }}</h1>
        <h2 class="display-1 font-weight-bold">{{ stepsData[0].subtitle }}</h2>
        <p>{{ stepsData[0].description }}</p>
        <v-btn color="accent" class="font-weight-bold" to="/registro/organizacion">
          Registrarme
          <v-icon right :style="getSmallSize">fas fa-arrow-right</v-icon>
        </v-btn>
        <!--
        <v-dialog v-model="dialog" max-width="700">
        <template v-slot:activator="{ on }">
            <v-btn v-on="on" color="accent" class="font-weight-bold">
              Registrarme 
              <v-icon right :style="getSmallSize">fas fa-arrow-right</v-icon>
            </v-btn>
        </template>
        <select-type-user-card></select-type-user-card>
        </v-dialog>-->
      </v-col>
      <v-col cols="10" sm="6" md="5" lg="5" xl="4" class="mx-md-5 mt-5 mt-sm-0">
        <v-img src="@/assets/img/Paso1.png"></v-img>
      </v-col>
    </v-row>

    <v-row justify="center" align="center" class="pa-5 my-5 d-flex">
      <v-col cols="10" sm="6" md="5" lg="5" xl="4" class="mx-md-5" :class="($vuetify.breakpoint.xsOnly)?'order-2':'order-1'">
        <v-img src="@/assets/img/Paso2.png"></v-img>
      </v-col>
      <v-col cols="12" sm="6" md="5" lg="6" xl="4" class="text-center mx-md-5" :class="($vuetify.breakpoint.xsOnly)?'order-1':'order-2'">
        <h1 class="display-2 font-weight-black">{{ stepsData[1].title }}</h1>
        <h2 class="display-1 font-weight-bold">{{ stepsData[1].subtitle }}</h2>
        <p>{{ stepsData[0].description }}</p>
      </v-col>  	
    </v-row>

    <v-row justify="center" align="center" class="pa-5 mt-5 mt-lg-10 pt-lg-10">
      <v-col cols="12" md="10" lg="8" class="text-center">
        <h1 class="display-2 font-weight-black">{{ stepsData[2].title }}</h1>
        <h2 class="display-1 font-weight-bold">{{ stepsData[2].subtitle }}</h2>
        <p>
          Evalúa el desempeño de tus eventos en tiempo real, WeChamber hará una transferencia a la cuenta de tu preferencia de manera semanal.
        </p>
      </v-col>
      <v-col cols="12" sm="6" md="5" lg="5" class="mx-md-5">
        <v-img src="@/assets/img/Paso3.png"></v-img>
      </v-col>
    </v-row>
    <!-- SECCIÓN DEL BANNER -->
    <v-row justify="center" align="center">
      <v-col cols="12">
        <banner
          theme="dark"
          title="¿Estás listo?"
          content="Comienza a organizar tus eventos con nosotros."
          btnText="¡Quiero ser organizador!"
          to="/registro/organizacion"
        ></banner>
      </v-col>
    </v-row>
    <!-- SECCIÓN DEL BANNER -->

    <!-- SECCIÓN PARA ASISTENTES -->
    <v-row justify="center" align="center">
      <v-col cols="12" class="text-center" data-aos="fade-in" data-aos-duration="350">
        <h1 class="display-2 font-weight-bold mt-5">Para asistentes</h1>
        <h2 class="headline">Con estos sencillos pasos puedes capacitarte en lo que más te guste</h2>
      </v-col>
      <v-col cols="10" sm="3" xl="2" data-aos="zoom-in" data-aos-duration="450">
        <simple-card :data="guestsData[0]" theme="dark" iconColor="white" padding="pa-5" :hover="true"></simple-card>
      </v-col>
      <v-col cols="12" sm="1" data-aos="fade-in" data-aos-duration="450">
        <v-row justify="center">
          <v-icon color="accent" v-bind:style="getSize">fa-angle-double-right</v-icon>
        </v-row>
      </v-col>
      <v-col cols="10" sm="3" xl="2" data-aos="zoom-in" data-aos-duration="450">
        <simple-card :data="guestsData[1]" theme="dark" iconColor="white" padding="pa-5" :hover="true"></simple-card>
      </v-col>
      <v-col cols="12" sm="1" data-aos="fade-in" data-aos-duration="450">
        <v-row justify="center">
          <v-icon color="accent" v-bind:style="getSize">fa-angle-double-right</v-icon>
        </v-row>
      </v-col>
      <v-col cols="10" sm="3" xl="2" data-aos="zoom-in" data-aos-duration="450">
        <simple-card :data="guestsData[2]" theme="dark" iconColor="white" padding="pa-5" :hover="true"></simple-card>
      </v-col>
    </v-row>
    <!-- SECCIÓN PARA ASISTENTES -->

    <!-- SECCIÓN PARA ORGANIZADORES -->
    <v-row justify="center" align="center" class="my-5 py-5 mb-10 pb-10">
      <v-col cols="12" class="mt-5 text-center" data-aos="fade-in" data-aos-duration="350">
        <h1 class="display-2 font-weight-bold mt-5">Para organizadores</h1>
        <h2 class="headline">Sigue estos sencillos pasos para organizar tus eventos</h2>
      </v-col>
      <v-col cols="10" sm="3" xl="2" data-aos="zoom-in" data-aos-duration="450">
        <simple-card :data="managersData[0]" theme="dark" iconColor="white" padding="pa-5" :hover="true"></simple-card>
      </v-col>
      <v-col cols="12" sm="1" data-aos="fade-in" data-aos-duration="450">
        <v-row justify="center">
          <v-icon color="accent" v-bind:style="getSize">fa-angle-double-right</v-icon>
        </v-row>
      </v-col>
      <v-col cols="10" sm="3" xl="2" data-aos="zoom-in" data-aos-duration="450">
        <simple-card :data="managersData[1]" theme="dark" iconColor="white" padding="pa-5" :hover="true"></simple-card>
      </v-col>
      <v-col cols="12" sm="1" data-aos="fade-in" data-aos-duration="450">
        <v-row justify="center">
          <v-icon color="accent" v-bind:style="getSize">fa-angle-double-right</v-icon>
        </v-row>
      </v-col>
      <v-col cols="10" sm="3" xl="2" data-aos="zoom-in" data-aos-duration="450">
        <simple-card :data="managersData[2]" theme="dark" iconColor="white" padding="pa-5" :hover="true"></simple-card>
      </v-col>
    </v-row>
    <!-- SECCIÓN PARA ORGANIZADORES -->

    <w-footer></w-footer>
  </v-container>
</template>
<script>
import wFooter from "@/components/shared/w-footer";
import selectTypeUserCard from "@/components/landing/select-type-user-card.vue";
import simpleCard from "@/components/landing/simple-card";
import banner from "@/components/landing/banner";
import stepCard from "@/components/landing/step-card";
export default {
  components: {
    wFooter,
    selectTypeUserCard,
    simpleCard,
    banner,
    stepCard
  },
  data() {
    return {
      stepsData: [
        {
          title: "Paso 1",
          subtitle: "Regístrate como Organizador",
          description:
            "Queremos conocer mejor a tu organización, un ejecutivo de WeChamber te contactará y habilitaremos tu cuenta.",
        },
        {
          title: "Paso 2",
          subtitle: "Configura y publica tu primer evento",
          description:
            "Crea tú mismo el micrositio de tus eventos con WeChamber y comienza tu estrategia de difusión.",
        },
        {
          title: "Paso 3",
          subtitle: "Vende y gestiona en línea",
        }
      ],
      guestsData: [
        {
          id: 1,
          icon: "fas fa-search",
          description: "Encuentra cursos interesantes."
        },
        {
          id: 2,
          icon: "fas fa-sign-in-alt",
          description: "Regístrate en alguno de ellos."
        },
        {
          id: 3,
          icon: "fas fa-check-square",
          description: "Selecciona un método de pago."
        }
      ],
      managersData: [
        { id: 1, icon: "fas fa-user-circle", description: "Crea una cuenta." },
        {
          id: 2,
          icon: "fas fa-calendar-day",
          description: "Publica tus eventos."
        },
        {
          id: 3,
          icon: "fas fa-chart-bar",
          description: "Gestiónalos en línea."
        }
      ]
    };
  },
  computed: {
    getSmallSize(){
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
          return "font-size:1.2em";
        case "sm":
          return "font-size:1.1em";
        case "md":
          return "font-size:1em";
        case "lg":
          return "font-size:1.1em";
        case "xl":
          return "font-size:1.3em";
      }
    },
    getSize() {
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
          return "font-size:2.5em";
        case "sm":
          return "font-size:3em";
        case "md":
          return "font-size:3em";
        case "lg":
          return "font-size:3em";
        case "xl":
          return "font-size:5em";
      }
    }
  }
};
</script>
<style scoped>
.order-1{
  order: 1;
}
.order-2{
  order: 2;
}

.color-yellow{
  color: #fcc401;
}

.color-black{
  color: #000000;
}

/*
ul {list-style: none}

li::before {content: "•"; color: #3bbde0}

li::before {content: "•"; color: #3bbde0;
  display: inline-block; width: 1em;
  margin-left: -1em}

/*
ul li::before {content: counter(li); color: red; width: 1em; margin-left: -1.5em;
    margin-right: 0.5em;}*/
</style>